<template>
  <div>
    <footer class="main-footer">
      <div class="pull-right hidden-xs">
        <b>{{$store.getters.getCompanyName}}</b>
        v{{version}}
      </div>
      <strong>
        <i class="fa fa-building"></i> {{user.companyName}}
      </strong>
    </footer>
  </div>
</template>
<script>
export default {
  computed : {
    version() {
      return this.$store.getters.getVersion;
    },
    user(){
      return this.$store.getters.getUser;
    }
  },
  created(){
    let version = localStorage.getItem("tVersion");
    if (version != this.version) {
      localStorage.setItem("tVersion", this.version);
      window.location.reload();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/shared/Footer.vue